export default "__VITE_ASSET__08a431a2__"